/** A sessão do navegador (ADR 0039): quem está entrando e como sair. Sem CSS, sem React — a entrada carrega antes de tudo. */

/** ADR 0047: um cockpit que o SERVIDOR disse que a pessoa tem. Não concede nada: as rotas seguem exigindo as capacidades. */
export type CockpitDisponivel = { readonly id: string; readonly rotulo: string; readonly descricao: string; readonly rota: string };

export type SessaoDoNavegador = {
  readonly via: 'cookie' | 'bearer';
  readonly usuario: { readonly login: string; readonly nome: string; readonly papeis: ReadonlyArray<string> };
  readonly permissoes: ReadonlyArray<string>;
  /** ADR 0048: DEMONSTRACAO (só sintético) ou OPERACIONAL — a verdade do servidor. */
  readonly tenantNatureza: 'DEMONSTRACAO' | 'OPERACIONAL' | null;
  readonly cockpitPadrao: string | null;
  readonly cockpitsDisponiveis: ReadonlyArray<CockpitDisponivel>;
  /** ADR 0048: o servidor diz se o Grafana deste ambiente serve esta pessoa (tenant do Grafana + observabilidade.ler). */
  readonly grafanaDisponivel?: boolean;
};

/** Mostrar os links do Grafana? Só quando o servidor disse que sim — sem a informação (API antiga, erro), não. */
export function grafanaDisponivel(sessao: Pick<SessaoDoNavegador, 'grafanaDisponivel'> | null | undefined): boolean {
  return sessao?.grafanaDisponivel === true;
}

/** A sessão desta aba (ou nula, se a API diz 401). Outros erros sobem: a tela não finge que é falta de login. */
export async function sessaoAtual(): Promise<SessaoDoNavegador | null> {
  const r = await fetch('/api/auth/eu');
  if (r.status === 401) return null;
  if (!r.ok) throw new Error(`a API respondeu ${r.status} ao conferir a sessão.`);
  return (await r.json()) as SessaoDoNavegador;
}

/** Encerra a sessão do navegador (revoga no banco e apaga o cookie) e volta à entrada. */
export async function sairDaSessao(): Promise<void> {
  await fetch('/api/auth/sair', { method: 'POST' }).catch(() => undefined);
  location.reload();
}
